import { render, staticRenderFns } from "./SafetySuppliesOrderTableList.vue?vue&type=template&id=6df7c3fa&scoped=true"
import script from "./SafetySuppliesOrderTableList.vue?vue&type=script&lang=js"
export * from "./SafetySuppliesOrderTableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df7c3fa",
  null
  
)

export default component.exports